import React from 'react';
import { StackProps } from '@moda/om';
import classNames from 'classnames';

import './Box.scss';

interface Props extends Omit<StackProps, 'space'> {
  className?: string;
  borderless?: boolean;
}

export const Box: React.FC<Props> = ({ children, className = '', borderless, ...rest }) => (
  <div className={classNames('Box', className, { 'Box--borderless': borderless })} {...rest}>
    {children}
  </div>
);
